/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import SettingsPageSidebarPropTypes from './Settings.page.sidebar.props';
import settingsPageStyles from './Settings.page.styles';

/**
 * SettingsPageSidebarComponent
 * @export
 * @class SettingsPageSidebarComponent
 * @extends {React.Component<SettingsPageSidebarComponentComposedProps, SettingsPageSidebarComponentState>}
 */
export class SettingsPageSidebarComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<SettingsPageSidebarComponentProps>}
   * @memberof SettingsPageSidebarComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`SettingsPageSidebar`}
   * @memberof SettingsPageSidebarComponent
   */
  static displayName = `SettingsPageSidebar`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof SettingsPageSidebarComponent
   */
  static propTypes = SettingsPageSidebarPropTypes;

  /**
   * Data specific to the `<SettingsPageSidebar />` instance
   * @type {SettingsPageSidebarComponentState}
   * @memberof SettingsPageSidebarComponent
   */
  state = {};

  /**
   * Render the sidebar
   * @returns {React.Component} The rendered `<SettingsPageSidebar />`
   * @memberof SettingsPageSidebarComponent
   */
  render() {
    return null;
  }
}

/** @type {React.ComponentClass<SettingsPageSidebarComponentProps>} */
const SettingsPageSidebar = compose(withStyles(themeCreateInjectableStyles(settingsPageStyles), { withTheme: true }))(SettingsPageSidebarComponent);

export default SettingsPageSidebar;
